import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BuildFormRequestComponent } from './build-form-request/build-form-request.component';
import { UploadFileComponent } from 'src/app/shared/upload-file/upload-file.component';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [BuildFormRequestComponent,UploadFileComponent],
  exports:[BuildFormRequestComponent,UploadFileComponent],
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule
  ]
})
export class BuildFormModuleModule { }
